import { Frame, State } from 'features/Frames/types';

export const generateFilters = (frames: Frame[]) => {
  const publisherSet = new Set<string>();
  const environmentSet = new Set<string>();
  const formatSizeSet = new Set<string>();
  const resolutionSet = new Set<string>();
  const statusSet = new Set<State | undefined>();

  frames.forEach((frame) => {
    publisherSet.add(frame.publisher);
    environmentSet.add(frame.environment);
    formatSizeSet.add(frame.formatSize);
    resolutionSet.add(frame.resolution);
    statusSet.add(frame.status?.state);
  });

  return {
    publisher: Array.from(publisherSet),
    environment: Array.from(environmentSet),
    formatSize: Array.from(formatSizeSet),
    resolution: Array.from(resolutionSet),
    status: Array.from(statusSet),
  };
};
